import Decimal from 'decimal.js';

// Keep the ledger's decimal strings intact; converting crypto to Number loses digits.
export const formatAmount=(value,currency,language='tr')=>{
  try{
    const places=['TRY','USD','EUR','GBP'].includes(currency)?2:18;
    const decimal=new Decimal(value??0);
    if(!decimal.isFinite())return '—';
    const [integer,fraction='']=decimal.toDecimalPlaces(places,Decimal.ROUND_HALF_UP).toFixed().split('.');
    const tr=language==='tr',grouped=integer.replace(/\B(?=(\d{3})+(?!\d))/g,tr?'.':',');
    return `${grouped}${tr?',':'.'}${fraction.padEnd(2,'0')} ${currency||''}`;
  }catch{return '—';}
};